import React from 'react';
import {FormControl, InputLabel, MenuItem, Select, Stack, Typography} from "@mui/material"
import {AnyColumnJson, ColumnPredefinedOptionsJson} from "../../api/json/ColumnJson"
import ClassifierTemplateUtil from "../../library/ClassifierTemplateUtil"
import TemplateUtil from "../../library/TemplateUtil"
import ClassChip from "../common/ClassChip"
import {resolveClassColor} from "../../library/ClassColors"

interface ClassifierOutputSelectProps {
    columns: AnyColumnJson[]
    value: string
    setValue: (value: string) => void
}

const CHIP_PREVIEW_LIMIT = 12

function ClassifierOutputSelect({columns, value, setValue}: ClassifierOutputSelectProps) {
    const optionsColumns = ClassifierTemplateUtil.optionsColumns(columns) as ColumnPredefinedOptionsJson[]

    const match = value.match(ClassifierTemplateUtil.outputPattern)
    const selectedReference = match && optionsColumns.some(column => column.reference === match[1]) ? match[1] : ""
    const selected = optionsColumns.find(column => column.reference === selectedReference)

    return (
        <Stack spacing={1}>
            <FormControl>
                <InputLabel id="classifier-output-label">Output</InputLabel>
                <Select labelId="classifier-output-label"
                        label="Output"
                        value={selectedReference}
                        onChange={event => setValue(TemplateUtil.inDoubleBrackets(event.target.value))}>
                    {optionsColumns.map(column => (
                        <MenuItem key={column.reference} value={column.reference}>{column.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            {selected?.predefinedOptions && selected.predefinedOptions.length > 0 &&
                <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap alignItems="center">
                    {selected.predefinedOptions.slice(0, CHIP_PREVIEW_LIMIT).map(option => (
                        <ClassChip key={option.value}
                                   value={option.value}
                                   color={resolveClassColor(option.value, selected.predefinedOptions)}/>
                    ))}
                    {selected.predefinedOptions.length > CHIP_PREVIEW_LIMIT &&
                        <Typography variant="caption" color="text.secondary">
                            +{selected.predefinedOptions.length - CHIP_PREVIEW_LIMIT} more
                        </Typography>
                    }
                </Stack>
            }
        </Stack>
    )
}

export default ClassifierOutputSelect;
